import { ReactNode } from 'react'
import { Grid, Typography, useTheme, Box } from '@mui/material'

import { AccountIcon, UserWalletsBallatceList } from 'src/components'

import { FONTS } from 'src/constants'
import { UserIcon } from '../user-icon'
import useStyles from './styles'

interface IProps {
  title?: string | ReactNode
  withAccountIcon: boolean
}

const Header = ({ title, withAccountIcon }: IProps) => {
  const classes = useStyles()
  const theme = useTheme()

  return (
    <Grid container className={classes.headerWrapper} alignItems={'center'}>
      <Grid item className={classes.titleWrapper}>
        {withAccountIcon && (
          <div>
            <AccountIcon />
          </div>
        )}
        {title && (
          <Typography
            sx={{
              fontWeight: FONTS.WEIGHTS.bold,
              fontSize: FONTS.SIZES.xxxxxl,
              color: theme.palette.custom.darkBlue2,
            }}
          >
            {title}
          </Typography>
        )}
      </Grid>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '16px' }}>
        {/* <UserWalletsBallatceList /> */}
        <UserIcon />
      </Box>
    </Grid>
  )
}

export { Header }
